/**
 * ConfidenceBadge - Badge de confiance sur les drafts importés
 * 3 niveaux: "Ready to review" (vert), "Needs a look" (orange), "Needs your help" (rouge)
 *
 * PRD: docs/PRDs/PRD-import-intelligent-events.md
 */

import React from 'react';
import { getConfidenceConfig } from '../../../types/import.types';

interface ConfidenceBadgeProps {
  confidence: number;
  className?: string;
}

const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({ confidence, className = '' }) => {
  const config = getConfidenceConfig(confidence);

  return (
    <span className={`confidence-badge ${config.className} ${className}`}>
      {config.label}
    </span>
  );
};

export default React.memo(ConfidenceBadge);
